/**
 * @module app.cm
 */

import { autoinject } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { INotesConfig } from 'app/core/models/essette-interfaces';
@autoinject()
export class ManageBarrierNotesPage {
    protected displayTabs: Record<string, boolean> = {};

    ////****************** Fields and Properties ************************************////
    protected notesConfig: INotesConfig = {
        serviceRootUrl: 'cm/careplans/outcomes',
        targetType: 'CM.CarePlan',
        moduleCode: 'CM'
    };

    protected captionPrefix: string | null = "Outcome";

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly logger: AppLogger) {
        this.logger.source = this;
    }

    ////****************** Element References ***************************************////

    ////****************** Functions ************************************************////
    protected displayTabContents(tabId: string): void {
        this.displayTabs[tabId] = true;
    }

}
